import Table from "@wielink/datatables";
import Connect from "@jntestapparatuur/cylinder/js/datatables/renderers/connect";
import Disconnect from "@jntestapparatuur/cylinder/js/datatables/renderers/disconnect";
import DefaultRenderers from "@wielink/datatables/Renderers/DefaultRenderers";
import Alert from "@wielink/datatables/Alert";

class CylinderTable extends Table {
	constructor(config) {
		super(Object.assign({
			renderers: {
				...DefaultRenderers,
				'connect': Connect,
				'disconnect': Disconnect
			}
		}, config));
	}

	defineButtons($table) {
		let buttons = super.defineButtons($table);

		let config = $table.data('config');

		if (config.connectUrl) {
			buttons.buttons.push({
				text: 'Koppelen',
				className: 'btn btn-success',
				action: this.bulkConnect.bind(this)
			});
		}

		if (config.disconnectUrl) {
			buttons.buttons.push({
				text: 'Ontkoppelen',
				className: 'btn btn-danger',
				action: this.bulkDisconnect.bind(this)
			});
		}

		return buttons;
	}

	after(datatable) {
		super.after(datatable);
		this.$scope.on('click', '[data-dt-btn="connect"]', this.singleConnect.bind(this));
		this.$scope.on('click', '[data-dt-btn="disconnect"]', this.singleDisconnect.bind(this));
	}

	async bulkDisconnect(event, datatable, node, config) {
		if (!await Helpers.Alert.confirm('Weet u het zeker?')) {
			return;
		}

		let ids = datatable.rows({selected: true}).data().toArray().map((row) => row.id);

		if (ids.length < 1) {
			Helpers.Alert.alert('Selecteer minimaal één rij.')
			return;
		}

		datatable.rows({selected: true}).deselect();

		this.disconnect(datatable, ids);
	}

	async singleDisconnect(event) {
		event.preventDefault();

		if (!await Helpers.Alert.confirm('Weet u het zeker?')) {
			return;
		}

		let $target = $(event.currentTarget);
		if ($target.is('tr')) {
			$target = $target.find('[data-dt-btn="disconnect"]')
		}

		let $table = $target.closest('.dataTable');

		this.disconnect($table.DataTable(), [$target.data('id')]);
	}

	disconnect(datatable, ids) {
		let controllerUrl = $(datatable.table().body()).closest('table').data('config')['disconnectUrl'];

		$.ajax({
			url: controllerUrl,
			method: 'PUT',
			data: {
				_method: 'PUT',
				ids: ids
			},
			success: () => {
				datatable.ajax.reload();

				let $secondTable = $('.dataTable').eq(1).DataTable();
				if ($secondTable) {
					$secondTable.ajax.reload();
				}
			},
			error: (response) => {
				Helpers.Alert.alert(response.responseJSON.message);
				datatable.ajax.reload();
			}
		});
	}

	async bulkConnect(event, datatable, node, config) {
		let ids = datatable.rows({selected: true}).data().toArray().map((row) => row.id);

		if (ids.length < 1) {
			Helpers.Alert.alert('Selecteer minimaal één rij.')
			return;
		}

		datatable.rows({selected: true}).deselect();

		this.connect(datatable, ids);
	}

	async singleConnect(event) {
		event.preventDefault();

		let $target = $(event.currentTarget);
		if ($target.is('tr')) {
			$target = $target.find('[data-dt-btn="connect"]')
		}

		let $table = $target.closest('.dataTable');

		this.connect($table.DataTable(), [$target.data('id')]);
	}

	connect(datatable, ids) {
		let controllerUrl = $(datatable.table().body()).closest('table').data('config')['connectUrl'];

		$.ajax({
			url: controllerUrl,
			method: 'PUT',
			data: {
				_method: 'PUT',
				ids: ids
			},
			success: () => {
				datatable.ajax.reload();

				let $secondTable = $('.dataTable').eq(0).DataTable();
				if ($secondTable) {
					$secondTable.ajax.reload();
				}
			},
			error: (response) => {
				Helpers.Alert.alert(response.responseJSON.message);
				datatable.ajax.reload();
			}
		});
	}
}

export default CylinderTable;